module.exports = __webpack_public_path__ + "static/media/whatsapp-link.f4a0d0cd.svg";